import { _baseDateFormatter } from '@guiker/date'

import { useTranslation } from './index'

export const useDateFormatter = () => {
  const { i18n } = useTranslation()

  return _baseDateFormatter({ locale: i18n.language })
}
